"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Balance = void 0;
const cross_fetch_1 = require("cross-fetch");
const utils_1 = require("./utils");
const Fee_1 = require("./Fee");
const Assets_1 = require("./Assets");
class Balance {
    constructor(props) {
        this.balances = Object.create(null);
        this.feeList = [];
        this.hasData = false;
        this._onUpdateCbs = [];
        this._poll = null;
        const { address, iconUrl = 'https://waves.exchange/static/icons/assets', dataServicesUrl = 'https://waves.exchange/api/v1', nodeUrl = 'https://nodes.waves.exchange', updateBalancesMs = null } = props;
        this._updateBalancesMs = updateBalancesMs;
        this._assets = new Assets_1.Assets(dataServicesUrl, iconUrl);
        this.dataServicesUrl = dataServicesUrl;
        this.nodeUrl = nodeUrl;
        this.changeUser(address);
    }
    changeUser(address) {
        this.hasData = false;
        this.address = address;
        this.balances = Object.create(null);
        this.feeList = [];
        this._readyPromise = null;
        const emptyBalances = Object.entries(this.balances)
            .reduce((acc, [key, money]) => {
            acc[key] = money.cloneWithCoins(0);
            return acc;
        }, {});
        this._onUpdate(Object.create(null));
        if (!address) {
            return;
        }
        if (this._updateBalancesMs) {
            this._updateBalances(this._updateBalancesMs);
        }
        else {
            this._readyPromise = this._init();
        }
    }
    destroy() {
        this.offUpdate();
        if (this._poll) {
            this._poll.stop();
            this._poll = null;
        }
    }
    getFeesByCoins(coins) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this._readyPromise;
            const number = coins instanceof utils_1.MyMoney ? coins.getCoins() : coins;
            return Fee_1.getFeesByWavesMoney(this.feeList, new utils_1.MyMoney(number, this._wavesAsset));
        });
    }
    getFees(tx) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this._readyPromise;
            return Fee_1.getFeeByTx(this._wavesAsset, this.feeList, tx, this.nodeUrl);
        });
    }
    getBalances() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._readyPromise) {
                return this._readyPromise;
            }
            this._readyPromise = this._init();
        });
    }
    onUpdate(cb) {
        this._onUpdateCbs.push(cb);
    }
    offUpdate(cb) {
        this._onUpdateCbs = cb ? this._onUpdateCbs.filter(item => item !== cb) : [];
    }
    _getBalances() {
        return __awaiter(this, void 0, void 0, function* () {
            const wavesResponse = yield this._fetchWavesBalances();
            const { balances } = yield this._fetchBalances();
            const assetsToGet = (balances || []).map((item) => item.assetId);
            const assets = yield this._assets.getAssets(['WAVES', ...assetsToGet]);
            const assetsHash = utils_1.toHash(assets, 'id');
            this._wavesAsset = assetsHash['WAVES'];
            const wavesBalance = new utils_1.MyMoney(wavesResponse.available, assetsHash['WAVES']);
            const balancesHash = balances.reduce((acc, item) => {
                const asset = assetsHash[item.assetId];
                acc[item.assetId] = new utils_1.MyMoney(item.balance, asset);
                return acc;
            }, Object.create(null));
            const newBalances = Object.assign(Object.assign({}, balancesHash), { WAVES: wavesBalance });
            const diff = this._getDiff(newBalances);
            this.hasData = true;
            if (!diff) {
                return null;
            }
            this.balances = newBalances;
            this.feeList = Object.values(this.balances).filter(item => {
                return item.asset.id === 'WAVES' || Number(item.asset.minSponsoredFee) > 0;
            });
            this._onUpdate(diff);
        });
    }
    _fetchWavesBalances() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield cross_fetch_1.default(`${this.nodeUrl}/addresses/balance/details/${this.address}`)
                .then((res) => {
                if (res.status >= 400) {
                    throw new Error('Bad response from server');
                }
                return res.text();
            })
                .then(utils_1.parseJSON);
        });
    }
    _fetchBalances() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield cross_fetch_1.default(`${this.nodeUrl}/assets/balance/${this.address}`)
                .then((res) => {
                if (res.status >= 400) {
                    throw new Error('Bad response from server');
                }
                return res.text();
            })
                .then(utils_1.parseJSON);
        });
    }
    _getDiff(balances) {
        const currentBalances = Object.values(this.balances);
        const newBalances = Object.values(balances);
        const iterateFromCurrent = currentBalances.length > newBalances.length;
        const iterateBalances = iterateFromCurrent ? currentBalances : newBalances;
        const moneyHash = iterateFromCurrent ? balances : this.balances;
        return iterateBalances.reduce((acc, money) => {
            const id = money.asset.id;
            const refMoney = moneyHash[id];
            if (!refMoney) {
                acc = acc || Object.create(null);
                acc[id] = iterateFromCurrent ? new utils_1.MyMoney(0, money.asset) : money;
                return acc;
            }
            if (!refMoney.eq(money)) {
                acc = acc || Object.create(null);
                acc[id] = iterateFromCurrent ? refMoney : money;
            }
            return acc;
        }, null);
    }
    _init() {
        return __awaiter(this, void 0, void 0, function* () {
            while (true) {
                try {
                    yield this._getBalances();
                    break;
                }
                catch (e) {
                    console.error('Retry Fetch Balances', e);
                    yield utils_1.waitPromise(5000);
                }
            }
        });
    }
    _onUpdate(diff) {
        this._onUpdateCbs.forEach(item => item(this.balances, diff));
    }
    _updateBalances(timeMs) {
        this._poll = new utils_1.Poll(timeMs, () => {
            this._readyPromise = null;
            this._readyPromise = this.getBalances();
            return this._readyPromise;
        });
        this._poll.start();
    }
}
exports.Balance = Balance;
